/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-09 13:49:08
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CommonComponents from '@/components'
import i18n from './i18n'
import '@/style/main.less'
import ieVersion from 'ie-version'
import '@/util/vizier.js'

// import VConsole from 'vconsole'
// var vconsole = new VConsole()
// console.log(vconsole)
if ((ieVersion.version && ieVersion.version < 11) || !document.body.dataset) {
  alert('浏览器版本不支持，请使用新版浏览器访问')
  throw new Error('浏览器版本不支持，请使用新版浏览器访问')
}
if ((navigator.userAgent || navigator.appVersion).toLowerCase().indexOf('oppo') !== -1) {
  const viewportEle = document.querySelector('meta[name=viewport]')
  viewportEle.setAttribute('content', 'width=device-width, initial-scale=0.5, min-scale=0, shrink-to-fit=yes')
}

Vue.use(CommonComponents)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
